import { render, staticRenderFns } from "./InfosCard.vue?vue&type=template&id=7597001d&scoped=true&"
import script from "./InfosCard.vue?vue&type=script&lang=js&"
export * from "./InfosCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7597001d",
  null
  
)

export default component.exports